import { getRoutes } from './route'
import { getModules } from './store'
const getPlugins = () => []

export { getRoutes, getModules, getPlugins }
